import { type FieldPath, type FieldValues, type UseControllerReturn } from 'react-hook-form';

/**
 * Maps react-hook-form `useController` output to props for design-system inputs.
 * Omits `ref` from `controller.field` to avoid ref forwarding issues with function components.
 */
export function mapControllerToInputProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
  controller: UseControllerReturn<TFieldValues, TName>,
) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ref: _ref, ...fieldProps } = controller.field;
  return {
    testID: controller.field.name,
    error: controller.fieldState.error?.message,
    touched: controller.fieldState.isTouched,
    ...fieldProps,
  };
}
